import { isUndefined } from 'lodash';
import { fromJS } from 'immutable';
import { getViewInitialState } from 'src/store/view/reducer';
import { INIT_APP } from 'src/store/view/constants';
import {
  TOGGLE_FILTERS_PANEL,
  TOGGLE_SUBSCRIBE_POPUP,
  SET_IS_HOTEL_ONLY,
} from '../constants/view';
import { SEARCH_SUCCESS } from '../constants/search';
import { setFiltersPriorityPresetAction } from '../store/view/sagaActions';

const initialState = fromJS(getViewInitialState());

// TODO: refactor! hideSidebar -> showSidebar
export default function searchViewReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_APP:
      return state.set('app', action.payload.appName);
    case setFiltersPriorityPresetAction.type:
      return state.set('filtersPriority', action.payload);
    case TOGGLE_FILTERS_PANEL: {
      const toggleState = action.payload;
      const showSidebar = isUndefined(toggleState)
        ? state.get('hideSidebar')
        : toggleState;
      return state.set('hideSidebar', !showSidebar);
    }
    case TOGGLE_SUBSCRIBE_POPUP: {
      const toggleState = state.get('showSubscribePopup');
      return state.set('showSubscribePopup', !toggleState);
    }
    case SET_IS_HOTEL_ONLY: {
      return state.set('isHotelOnly', action.payload);
    }
    case SEARCH_SUCCESS: {
      return state.withMutations((s) =>
        s
          .set('currencySymbol', action.payload.currency_symbol)
          .set('currencyCode', action.payload.currency_code),
      );
    }
    default:
      return state;
  }
}
